// The "your role changed" notice must survive the reload that follows the forced logout,
// otherwise only "No estás loggeado" is seen. Kept for one page load in sessionStorage (client accounts only).
const KEY = 'inn.roleChangedNotice';

export function markRoleChanged(): void {
  try { sessionStorage.setItem(KEY, '1'); } catch { /* storage blocked: the notice is simply not shown */ }
}

export function consumeRoleChanged(): boolean {
  try {
    const pending = sessionStorage.getItem(KEY) === '1';
    sessionStorage.removeItem(KEY);
    return pending;
  } catch {
    return false;
  }
}
